import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/header';

// Define the API base using the domain name instead of IP address
const API_BASE = 'https://storetoyou.ca/api';

const ProductPage = () => {
  const { city, storeName, productId } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    console.log(`Fetching product: ${storeName}/product/${productId}`);
    
    // Remove the city from the API call since the backend doesn't expect it
    fetch(`${API_BASE}/stores/${storeName}/products/${productId}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log("Product data received:", data);
        setProduct(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching product:', err);
        setError(`Error loading product: ${err.message}`);
        setLoading(false);
      });
  }, [city, storeName, productId]);
  
  if (loading) return <div className="container text-center py-5">Loading...</div>;
  if (error) return <div className="container text-center py-5 text-danger">{error}</div>;
  if (!product) return <div className="container text-center py-5">Product not found</div>;
  
  return (
    <div className="container py-5">
      <Header />
      
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><Link to="/">Home</Link></li>
          <li className="breadcrumb-item"><Link to={`/${city}/${storeName}`}>{storeName}</Link></li>
          <li className="breadcrumb-item active">{product.name}</li>
        </ol>
      </nav>
      
      <div className="row">
        <div className="col-md-6">
          <img 
            src={product.image_url?.startsWith('/uploads') ? 
              `https://storetoyou.ca${product.image_url}` : 
              product.image_url || '/placeholder-image.jpg'}
            alt={product.name}
            className="img-fluid rounded"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/placeholder-image.jpg';
            }}
          />
        </div>
        <div className="col-md-6">
          <h1 className="mb-4">{product.name}</h1>
          <p className="lead">${product.price}</p>
          <p className="mb-4">{product.description}</p>
          <div className="d-grid gap-2">
            <button className="btn btn-primary btn-lg">Contact Store</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPage;